import { isArray, isPlainObject, camelCase as camelCase$1, snakeCase as snakeCase$1 } from 'lodash';
import { map } from 'rxjs/operators';

function isNullOrUndefined(obj) {
  return obj == null;
}
function isDefined(obj) {
  return obj !== null && obj !== undefined;
}
function isArrayDefined(arr) {
  return isDefined(arr) && arr.every(isDefined);
}
const isNullOrEmptyString = input => isNullOrUndefined(input) || input === '';

const mapWhenDefined = (...args) => {
  const values = args.slice(0, args.length - 1);
  const selector = args[args.length - 1];
  return isArrayDefined(values) ? selector(...values) : undefined;
};

/**
 * This util function makes sure that an array is returned.
 * Similar to lodash' `castArray`, with the key difference being that this function resolves `undefined` as [].
 *
 * ## Example:
 * ```ts
 * ensureArray(undefined) // []
 * castArray(undefined) // [undefined]
 * ```
 *
 * Given this difference, there is use for this util.
 */
function ensureArray(data) {
  if (Array.isArray(data)) {
    return data;
  } else if (data == null) {
    return [];
  } else {
    return [data];
  }
}

const recursiveKeysConvertCase = convertFunc => input => {
  if (isArray(input)) {
    return input.map(recursiveKeysConvertCase(convertFunc));
  } else if (isPlainObject(input)) {
    const newObj = {};
    Object.keys(input).forEach(key => {
      const newKey = convertFunc(key);
      newObj[newKey] = recursiveKeysConvertCase(convertFunc)(input[key]);
    });
    return newObj;
  }
  return input;
};

const recursiveKeysCamelCase = recursiveKeysConvertCase(camelCase$1);
const camelCase = value => recursiveKeysCamelCase(value);
const toCamelcase = () => source$ => source$.pipe(map(value => camelCase(value)));

const recursiveKeysSnakeCase = recursiveKeysConvertCase(snakeCase$1);
const snakeCase = value => recursiveKeysSnakeCase(value);
const toSnakeCase = () => source$ => source$.pipe(map(value => snakeCase(value)));

export { camelCase, ensureArray, isArrayDefined, isDefined, isNullOrEmptyString, isNullOrUndefined, mapWhenDefined, snakeCase, toCamelcase, toSnakeCase };
